import React, { Component } from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { blueGrey } from '@material-ui/core/colors';
import ErrorBoundary from 'react-error-boundary';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import axios from 'axios';
import LogRocket from 'logrocket';
import Book from './components/Book/Book';
import BookSolutions from './components/BookSolutions/BookSolutions';
import CssBaseline from '@material-ui/core/CssBaseline';
import config from './config';
import { setActor, trackSignInOnce } from './utils/analytics';

const theme = createTheme({
  palette: {
    type: 'dark',
    background: {
      default: blueGrey[50],
      paper: '#2D3047',
    },
    primary: {
      main: '#0577b9',
    },
  },
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      authenticationSettled: false,
    };
  }

  componentDidMount() {
    this.authenticationActive = true;
    setActor(null);
    axios.get(config.api.DOMAIN + '/api/auth/authenticate', { withCredentials: true })
    .then(responseData => {
      this.completeAuthentication(responseData.data.current_user || null);
    }, error => {
      if (!this.authenticationActive) { return; }
      console.error(error);
      this.completeAuthentication(null);
    });
  }

  completeAuthentication(currentUser) {
    if (!this.authenticationActive) { return; }
    setActor(currentUser);
    this.setState({ currentUser, authenticationSettled: true }, () => {
      if (!this.authenticationActive || !currentUser) { return; }
      try {
        if (config.env === 'production') {
          LogRocket.identify(currentUser.id, {
            name: `${currentUser.firstname} ${currentUser.lastname}`,
            email: currentUser.email,
          });
        }

        if (config.env !== 'local') {
          this.bootIntercom();
        }
      } catch (error) {
        console.error(error);
      }
    });
  }

  onAnalyticsContextReady = () => {
    if (this.authenticationActive && this.state.authenticationSettled && this.state.currentUser) {
      trackSignInOnce();
    }
  };

  componentWillUnmount() {
    this.authenticationActive = false;
    setActor(null);
  }

  bootIntercom() {
    const { currentUser } = this.state;
    if (!currentUser || !window.Intercom) { return; }

    window.Intercom('boot', {
      app_id: config.intercomAppId,
      fwkApplication: 'Viewer',
      email: currentUser.email,
      user_id: currentUser.id,
      user_hash: currentUser.intercom_hash,
      hide_default_launcher: true,
    });
  }

  errorHandler(error, _componentStack) {
    const slack = require('./slack');
    slack.sendSlackError(error.stack);
  };

  render() {
    const readerProps = {
      currentUser: this.state.currentUser,
      authenticationSettled: this.state.authenticationSettled,
      onAnalyticsContextReady: this.onAnalyticsContextReady,
    };

    return (
      <ErrorBoundary onError={this.errorHandler}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Switch>
              <Route path="/books/:book_id/solutions/:filename" render={(props) => <BookSolutions {...props} {...readerProps} />} />
              <Route path="/books/:book_id/:chapter_id/:section_id?/:element_id?" render={(props) => <Book {...props} {...readerProps} />} />
            </Switch>
          </Router>
        </ThemeProvider>
      </ErrorBoundary>
    );
  }
}

export default App;
